<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-child</v-icon>{{$t('qualitycheck.distributor.distributors')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <DistributorForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import DistributorForm from '../../components/distributor/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Distributor';

const { mapFields } = createHelpers({
  getterType: 'distributor/getField',
  mutationType: 'distributor/updateField'
});

export default {
  name: 'DistributorCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    DistributorForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('distributor', ['create', 'reset'])
  }
};
</script>
